export const formatPrice = (price: number | string) => {
    if (!price) return null
    return `€ ${parseFloat(price.toString()).toFixed(2).replace('.', ',').replace(',00', ',-')}`
}
